var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoVacancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-158-22H992v754H-158z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3.241,
    transform: "translate(16.403 19.109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.483 45.378h81.032v42.137H6.483z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.998,
    cy: 8.103,
    r: 8.103
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.102 25.93v9.724M64.825 35.654H29.171v-8.103c0-6.266 5.08-11.345 11.345-11.345H53.48c6.265 0 11.344 5.08 11.344 11.345v8.103zM38.895 25.93v9.724M40.516 69.687a4.862 4.862 0 1 1-9.724 0v-1.62h9.724v1.62zM63.205 69.687a4.862 4.862 0 1 1-9.724 0v-1.62h9.724v1.62zM30.792 68.067l4.862-12.965 4.862 12.965M53.481 68.067l4.862-12.965 4.862 12.965"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.998,
    cy: 55.102,
    r: 3.241
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.24 55.102h8.103M43.757 55.102h-8.103M46.998 58.343v22.689M40.516 81.032H53.48"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.206,
    cy: 16.206,
    r: 6.483
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.689 29.171v6.483M29.171 35.654H3.241v-4.862a8.104 8.104 0 0 1 8.103-8.103h9.724a8.104 8.104 0 0 1 8.103 8.103v4.862zM9.724 29.171v6.483M0 87.514h93.997v6.483H0zM90.756 45.378H3.24L0 35.654h93.997zM46.998 22.689l-6.482-6.483H53.48z"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#000",
    fontFamily: "Monda-Bold, Monda",
    fontSize: 29.159,
    fontWeight: "bold",
    transform: "translate(16.274 14.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 69.69,
    y: 35
  }, "?")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVacancy);
export default __webpack_public_path__ + "static/media/ico-vacancy.69c5d761808d70ee68430170952b2590.svg";
export { ForwardRef as ReactComponent };